import { Controller } from '@hotwired/stimulus';

import Commenter from '@/modules/commenter';
import GradeTree from '@/modules/grade_tree';
import Voting from '@/modules/voting';

export default class extends Controller {
  connect() {
    new GradeTree().create();
    new Commenter().create();
    new Voting({ voteableType: 'Comment', wrapper: '.comment__card' }).create();
  }
}
